import { AppliancesPermissions } from './appliances.permissions';
import { AppliancesRoles } from './appliances.roles';

export const appliancesMappings = {
  [AppliancesPermissions.GET_APPLIANCES]: [AppliancesRoles.VIEWER],
  [AppliancesPermissions.MANAGE_APPLIANCES]: [AppliancesRoles.MANAGER],
};
